import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ClipboardList } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/i18n";
import { PageHeader } from "@/components/common/PageHeader";
import { EmptyState } from "@/components/common/EmptyState";
import { StatusBadge } from "@/components/common/StatusBadge";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Skeleton } from "@/components/ui/skeleton";

export default function Orders() {
  const { t, fmtCurrency, fmtDate } = useI18n();
  const navigate = useNavigate();
  const { data, isLoading } = useQuery({ queryKey: ["orders"], queryFn: async () => (await api.get("/orders")).data });

  return (
    <div>
      <PageHeader title={t("orders.title")} subtitle={t("orders.subtitle")} />
      <Card>
        {isLoading ? (
          <div className="space-y-2 p-4">{[...Array(4)].map((_, i) => <Skeleton key={i} className="h-10" />)}</div>
        ) : data.items.length === 0 ? (
          <EmptyState icon={ClipboardList} title={t("orders.empty")} testId="orders-empty" />
        ) : (
          <Table data-testid="orders-table">
            <TableHeader>
              <TableRow>
                <TableHead>{t("orders.number")}</TableHead>
                <TableHead>{t("quotes.customer")}</TableHead>
                <TableHead className="hidden md:table-cell">{t("common.created")}</TableHead>
                <TableHead className="text-right">{t("quotes.total")}</TableHead>
                <TableHead>{t("common.status")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.items.map((o) => (
                <TableRow key={o.id} className="cursor-pointer" onClick={() => navigate(`/orders/${o.id}`)} data-testid={`order-row-${o.id}`}>
                  <TableCell className="font-medium tabular-nums">{o.order_number}</TableCell>
                  <TableCell>{o.customer_name}</TableCell>
                  <TableCell className="hidden text-slate-500 md:table-cell">{fmtDate(o.created_at)}</TableCell>
                  <TableCell className="text-right tabular-nums font-medium">{fmtCurrency(o.total)}</TableCell>
                  <TableCell><StatusBadge status={o.status} labelKey={`orders.status_${o.status}`} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
    </div>
  );
}
